import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface EstablecimientoConProtocolosDialogProps {
  open: boolean;
  uidEstablecimiento: string;
  nombre: string;
  onClose: () => void;
}

export function EstablecimientoConProtocolosDialog({
  open,
  uidEstablecimiento,
  nombre,
  onClose,
}: EstablecimientoConProtocolosDialogProps): JSX.Element {
  const navigate = useNavigate();

  function handleVerProtocolos(): void {
    onClose();
    navigate(`/protocolos?establecimiento=${uidEstablecimiento}`);
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>No se puede eliminar</DialogTitle>
      <DialogContent>
        <DialogContentText>
          El establecimiento <strong>{nombre}</strong> tiene protocolos asociados.
          Eliminá esos protocolos primero o conservá el establecimiento.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
        <Button onClick={handleVerProtocolos} variant="contained">
          Ver protocolos
        </Button>
      </DialogActions>
    </Dialog>
  );
}
